import { render, staticRenderFns } from "./Retailer.vue?vue&type=template&id=2ed8ab6b&scoped=true&"
import script from "./Retailer.vue?vue&type=script&lang=js&"
export * from "./Retailer.vue?vue&type=script&lang=js&"
import style0 from "./Retailer.vue?vue&type=style&index=0&id=2ed8ab6b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed8ab6b",
  null
  
)

export default component.exports